export const MarginRuleType = {
  MARKUP: 'markup',
  MARGIN: 'margin',
};

export const MarginRuleDefaultNames = {
  ALL_CLUSTERS: 'All Business Units',
  ALL_CLIENTS: 'All Clients',
  ALL_SERVICES: 'All Data Sources',
};

export const MarginRuleRoute = {
  MARGINRULES: 'marginrules',
};

export const MarginRulePathName = {
  MARGINRULES: 'marginrules',
  MARGINRULEFORM_NEW: 'marginruleform:new',
  MARGINRULEFORM: 'marginruleform',
};
